import React from "react";
import { UserProvider } from "./contexts/UserContext/UserContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "./App.css";
import "@mantine/core/styles.css";

import { RouterProvider } from "react-router";
import { router } from "./Router/router";
import { ContextProvider } from "./contexts/ContextProvider";
import { ErrorBoundary } from "@/errors/ErrorBoundary";
import { ErrorFallback } from "@/errors/ErrorFallback";

function App() {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <UserProvider>
        <ContextProvider>
          <ErrorBoundary fallback={<ErrorFallback />}>
            <RouterProvider router={router} />
          </ErrorBoundary>
        </ContextProvider>
      </UserProvider>
    </QueryClientProvider>
  );
}

export default App;
